export type MainMenuItem = {
  title: string;
  icon: string;
  route: string;
}

export enum ResponseStatus {
  Undefined = '',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}

export type ErrorResponse = {
  code: number;
  message: string;
}

export type TokenResponse = {
  /* eslint-disable camelcase */
  access_token: string;
  expires_in: string;
  refresh_expires_in: string;
  refresh_token: string;
  token_type: string;
  not_before_policy: string;
  session_state: string;
  scope: string;
}

export type PermissionResponse = {};
